import Separator, { SeparatorProps } from 'components/atoms/separator'
import React, { Children, isValidElement } from 'react'

interface InBetweenSpacingProps extends SeparatorProps {
  children?: JSX.Element | JSX.Element[]
}

const InBetweenSpacing: React.FC<InBetweenSpacingProps> = ({
  size,
  children,
}) => {
  const filteredChildren = Children.toArray(children).filter(isValidElement)
  return (
    <React.Fragment>
      {Children.map(filteredChildren, (child, index) =>
        index === filteredChildren.length - 1
          ? child
          : [child, <Separator key={index} size={size} />]
      )}
    </React.Fragment>
  )
}

export default InBetweenSpacing
